module.exports = __webpack_public_path__ + "img/redbutton.07ffb60e.svg";